import type { AppDispatch, AppStore, RootState } from './store';
import { useDispatch, useSelector, useStore } from 'react-redux';

// Используем данные переменные вместо  `useDispatch` and `useSelector` - во всём приложении
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
